import { Box } from "@mui/material";
import React from "react";

const CustomBadge = ({ advantagePoint }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 2,
        right: 6,
        background: "#06623B",
        height: "15px",
        width: "15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "10px",
        borderRadius: "50%",
        color: "white",
      }}
    >
      {advantagePoint}
    </Box>
  );
};

export default CustomBadge;
